import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: '/boleto/:identificador',
  name: 'Boleto',
  component: function component() {
    return import(/* webpackChunkName: "publico" */'./pages/Boleto');
  },
  meta: {
    titulo: 'Boleto',
    chat: true,
    precisaAutenticacao: false,
    cabecalho: true,
    rodape: true,
    ambienteSeguro: true
  }
}];